export default {"src":"/_next/static/media/credit-card.8f2de1f6.svg","height":163,"width":252,"blurWidth":0,"blurHeight":0};